// global window: false
window.Modernizr   = window.Modernizr || require('./detection/modernizr');
require('./detection/console-log-fix');
